import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import Link from 'components/consumer/Link';
import IconUserAccount from 'components/icons/iconUserAccount';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';

const MobileNavbarLink = ({
  children,
  id,
  isNested = false,
  to,
  currentPage,
}) => {
  const locationFromRoute = useUserCurrentPageType();
  const location = currentPage ?? locationFromRoute;

  return (
    <Link
      to={to}
      // remove when room refresh/visualizer AB test is done
      onClick={
        children === 'Room Visualizer' || children === 'Room Refresh'
          ? () => {
              avo.ctaClicked({
                text: children,
                targetUrl: to,
                cta: 'Room Visualizer',
                location,
                component: 'Navbar',
              });
            }
          : undefined
      }
      className={classNames(
        'text-lg !text-gray flex justify-start px-5 py-3 no-underline hover:underline focus-visible:rounded-[3px] focus-visible:outline-offset-[-4px] flex-col items-start max-w-full',
        {
          'pt-2 px-[42px] pb-[9px]': isNested,
        }
      )}
      id={to}
    >
      {id === 'login' && (
        <IconUserAccount className="mr-4 relative top-[-2px]" />
      )}
      <span className="MobileNavbarLink__text">{children}</span>
    </Link>
  );
};

MobileNavbarLink.propTypes = {
  children: PropTypes.string,
  id: PropTypes.string,
  isNested: PropTypes.bool,
  to: PropTypes.string,
  currentPage: PropTypes.objectOf(PropTypes.object),
};

export default MobileNavbarLink;
